const album = '同福客栈精选';

export const initialTracks = [
  {
    url: '/assets/audio/侠客行.mp3',
    metaData: {
      title: '侠客行',
      artist: '虞霞/李小龙',
      album,
    },
  },
  {
    url: '/assets/audio/好久不见.mp3',
    metaData: {
      title: '好久不见',
      artist: '李小龙',
      album,
    },
  },
  {
    url: '/assets/audio/茉莉花.mp3',
    metaData: {
      title: '武林外传 茉莉花.',
      artist: 'Jeremy',
      album,
    },
  },
];
